<template>
    <div class="module_content">
        No records found
    </div>
</template>

<script>
export default {name: 'noRecordsFound'}
</script>



// WEBPACK FOOTER //
// src/globals/noRecordsFound.vue